import {
  addHtmlElementEventListener,
  renderWebComponent, setHtmlElementAttribute, string2obj
} from "../../../utils/utils";
import commonStyles from '../../styles/web-components.common.css';
import { EventBusComponent } from "../EventBusComponent";

export class QuestionTooltipComponent extends HTMLElement {
  props = {};

  static get observedAttributes() {
    return [ 'props' ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue)
      this.props = string2obj(newValue);
    this.render();
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open'});
    this.eventBus = EventBusComponent.getInstance();
  }

  connectedCallback() {
    addHtmlElementEventListener(this.shadowRoot, 'questionTooltipContainer', 'click', (e) => this.eventBus.publish('render-modal', {title: this.props.title, body: this.props.body, displayLabelTypes: this.props.displayLabelTypes}))
    if (!this.props.disableMouseHover) {
      addHtmlElementEventListener(this.shadowRoot, 'questionTooltipIcon', 'mouseover', (e) => this.changeIcon("/images/icons/question.svg"));
      addHtmlElementEventListener(this.shadowRoot, 'questionTooltipIcon', 'mouseout', (e) => this.changeIcon("/images/icons/question_light.svg"));

      if (this.props.id)
        this.eventBus.subscribe(`enable-hover-question-tooltip-${this.props.id}`, (enable) => this.changeIcon(`/images/icons/question${enable ? '' : '_light'}.svg`) );
    }
  }


  // Funzione che cambia l'icona da renderizzare a video
  changeIcon(path) {
    setHtmlElementAttribute(this.shadowRoot, 'questionTooltipIcon', "src", path)
  }



  render() {
    const html = `          
      <sup class="mr-1 cursor-pointer" id="questionTooltipContainer">
        <img src="${this.props.url ? this.props.url : '/images/icons/question_light.svg'}" id="questionTooltipIcon" alt="" width="16" height="16">
      </sup>  
    `

    renderWebComponent(html, this.shadowRoot, [commonStyles]);
  }
}

window.customElements.define("question-tooltip-component", QuestionTooltipComponent);